import React, {Fragment} from "react";


export default class ImageViewComponent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            fileName: this.props.fileName || ""
        };
    }

    getSrc() {
        return this.props.src || "";
    }

    openWindow() {
        if (!this.props.src.startsWith("blob:")) {
            let newWindow = window.open(this.props.src, this.props.id, 'left=20,top=20,width=500,height=500,toolbar=1,resizable=0');
            newWindow.focus();
        }
        return false;
    }

    openPdfWindow() {

        let newWindow = window.open(this.props.src, this.props.id, 'left=20,top=20,toolbar=1,resizable=0');
        newWindow.focus();
        return false;
    }

    onImageLoaded(){
        if(this.props.onImageLoaded){
            this.props.onImageLoaded();
        }
    }

    render() {
        if (this.getSrc().includes(".pdf?") || (this.state.fileName.includes(".pdf"))) {
            return <Fragment>
                <img src={"/assets/img/pdf-icon.png"}
                     style={this.props.style}
                     alt={this.props.alt}
                     onClick={this.openPdfWindow.bind(this)}
                     onLoad={this.onImageLoaded.bind(this)}
                />
            </Fragment>;
        }
        else {
            return <Fragment>
                <img src={this.props.src}
                     style={this.props.style}
                     alt={this.props.alt}
                     onClick={this.openWindow.bind(this)}
                     onLoad={this.onImageLoaded.bind(this)}
                />
            </Fragment>;
        }

    }
}
